'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/productAccordion'));
    processInclude(require('./product/productGallery'));
    processInclude(require('./product/productViewGallery'));
    processInclude(require('./product/productCtaBox'));
    processInclude(require('./product/downloadsEULA'));
    processInclude(require('./notifyme/backInStock'));
});
